export const partnerApplicationKeys = {
  all: () => ['partner-applications'] as const,
  byPerson: () => [...partnerApplicationKeys.all(), 'by-person'] as const,
  byId: (applicationId?: string) =>
    [...partnerApplicationKeys.all(), 'by-id', applicationId] as const,
};
